import { environment } from '../config/angular-environments/environment';

/** DEPENDENCIES LEGACY */
import jQuery from 'jquery';
declare global {
    interface Window {
        $: any;
        humanizeDuration: any;
        paymentContext:string;
    }
}
// FIxes an error with ibdc
window.$ = jQuery;
import 'angular';
import 'angular-animate';
import 'angular-aria';
import 'angular-bind-html-compile';
import 'angular-cookies';
import 'angular-credit-cards';
import 'angular-daterangepicker';
import 'angular-dynamic-locale';
import 'angular-local-storage';
import 'angular-messages';
import 'angular-recaptcha';
import 'angular-route';
import 'angular-sanitize';
import 'angular-scroll';
import 'angular-timer';
import 'angular-translate';
import 'angular-translate-loader-partial';
import 'angular-translate-loader-static-files';
import 'angular-ui-bootstrap';
import 'angular-ui-date'; // Can't resolve 'jquery-ui/datepicker' -> resolved in webpack alias
import 'angularjs-slider';
import 'bodymovin';
import 'bootstrap-tabdrop/build/js/bootstrap-tabdrop.min.js';
import 'components-jqueryui';
import 'jquery-placeholder';
import 'jquery.ioslist/dist/js/jquery.ioslist';
import 'ng-device-detector';
import 'ng-resize';
import 'rx-angular';
import 'ui-select';
import 'bootstrap/dist/js/bootstrap.js';
import humanizeDuration from 'humanize-duration';
window.humanizeDuration = humanizeDuration;
/** LIBRARIES */
import './decorators';
import 'ib-web-commons';
import 'ib-menus';
import 'ib-web-payments';

/** APP ANGULARJS */
import './ib-gift-cards-templates';
import './ib-gift-cards-app';
import './ib-gift-cards-app-config';
import './ib-gift-cards-constants';
import './app/core';
import './app/shared';
import './app/features';

/** INIT ANGULAR PROJECT */

import { IbGiftCardsAppModule } from './ib-gift-cards-app.module';
import { enableProdMode } from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


if (environment.production) {
    enableProdMode();
}
platformBrowserDynamic().bootstrapModule(IbGiftCardsAppModule);
